import { useEffect } from 'react';
import { useRouter } from 'next/navigation';
import { UserType } from '@diritto/common/account/constants/user.constant';
import { ModalType } from 'constants/modal';
import { useAuthState } from 'contexts/AuthProvider';
import { useShowAppInstallBottomModal } from 'state-hooks/modal/useShowAppInstallBottomModal';
import { useShowFavoriteCategoryBottomModal } from 'state-hooks/modal/useShowFavoriteCategoryBottomModal';
import { useClient } from 'ui-hooks/useClient';
import { useMedia } from 'ui-hooks/useMediaQuery';
import { ModalHandler } from 'utils/ModalHandler';
import { useHomeSettingState } from 'contexts/HomeSettingProvider';

export const useRootPageModal = ({ enable }: { enable?: boolean } = { enable: true }) => {
  // App 에서는 footer 를 보여주지 않는다.
  const client = useClient();
  const router = useRouter();
  const { isPc } = useMedia();
  const { user, partner, profile } = useAuthState();
  const { categoryIds } = useHomeSettingState();
  const showAppInstallBottomModal = useShowAppInstallBottomModal();
  const showFavoriteCategoryBottomModal = useShowFavoriteCategoryBottomModal();

  useEffect(() => {
    if (client.isWeb && !isPc) {
      showAppInstallBottomModal();
    }
  }, [client.isWeb, enable, isPc, showAppInstallBottomModal]);

  useEffect(() => {
    if (partner && user?.type === UserType.Partner && !partner.verifiedAt) {
      ModalHandler.show(ModalType.Alert, {
        title: '아직 파트너 계정으로 등록되지 않았어요.',
        description: '사업자등록증을 제출하지 않은 상태라면 사업자등록증을 제출해주세요.',
        confirmText: '확인',
        cancelText: '사업자등록증 제출',
        onCancel: () => {
          router.push('/accounts/partners/sign-up/verify-business-license');
        },
        onConfirm: () => {
          router.push('/accounts/sign-out');
        },
      });
    }
  }, [partner, router, showAppInstallBottomModal, user?.type]);

  useEffect(() => {
    if (!profile && categoryIds.length === 0) {
      showFavoriteCategoryBottomModal();
    }
  }, [showFavoriteCategoryBottomModal, profile, categoryIds]);
};
